// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageJson from '../../package.json';

export const environment = {
  production: false,
  urlBase: '/api/',
  urlUsersFiles: 'http://localhost:3011/storage/users',
  urlLogosFiles: 'http://localhost:3011/storage/logos',
  urlViewPdf: '/api/storage/',
  urlCopomex: '/postalCode/',
  tokenCopoMex: '3e6db104-6ee9-4745-a5d8-16ea45990ec5',
  version: packageJson.version + '-dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
